import Swiper from "swiper";
import { Autoplay, FreeMode } from "swiper/modules";

(function () {
  let newsSwiper = [];
  const swiperSliders = document.querySelectorAll(".logo-slider");
  let breakpoint = 1200; // Set the breakpoint for when to initialize Swiper

  function initSwiper() {
    for (let i = 0; i < swiperSliders.length; i++) {
      let slidesPerview = "auto";
      let slidesPerView600 = "auto";
      let slidesPerView900 = "auto";
      let spaceBetween900 = 30;

      if (swiperSliders[i].classList.contains("width-active")) {
        slidesPerview = 2;
        slidesPerView600 = 3;
        slidesPerView900 = 4;
        spaceBetween900 = 30;
      }

      newsSwiper[i] = new Swiper(swiperSliders[i], {
        modules: [Autoplay, FreeMode],
        freeMode: true,
        loop: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
        speed: 5000,
        slidesPerView: slidesPerview,
        spaceBetween: 45,
        freeModeMomentum: false,
        breakpoints: {
          600: {
            slidesPerView: slidesPerView600,
          },
          900: {
            slidesPerView: slidesPerView900,
            spaceBetween: spaceBetween900,
          },
        },
      });
    }
  }

  function checkBreakpoint() {
    for (let i = 0; i < swiperSliders.length; i++) {
      if (window.innerWidth < breakpoint && !newsSwiper[i]) {
        initSwiper();
      } else if (window.innerWidth >= breakpoint && newsSwiper[i]) {
        newsSwiper[i].destroy(true, true);
        newsSwiper[i] = null;
      }
    }
  }

  window.addEventListener("resize", checkBreakpoint);
  checkBreakpoint();
})();
